import { useState, type FormEvent } from 'react';

import { ApiError } from '../api/client';
import { checkInvite } from '../api/endpoints/signup';
import { ErrorBanner } from '../components/ErrorBanner';
import { FormField } from '../components/FormField';
import { RegistroPage } from './Registro';

const WRONG_CODE = 'La clave de la invitación no es correcta.';
const TOO_MANY = 'Demasiados intentos. Espera un rato y vuelve a intentarlo.';
const FALLBACK = 'No pudimos revisar la clave. Intenta de nuevo.';

function inviteErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.status === 403) return WRONG_CODE;
  if (error instanceof ApiError && error.status === 429) return TOO_MANY;
  return FALLBACK;
}

/**
 * Martín's invitation (2026-11-02): a link he hands out with a password. The
 * password opens the usual signup, which then starts the business with three
 * months free on any plan; the server checks the password again on signup.
 */
export function InvitacionPage() {
  const [code, setCode] = useState('');
  const [accepted, setAccepted] = useState<string | undefined>();
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState<string | undefined>();

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setChecking(true);
    setError(undefined);
    try {
      await checkInvite(code);
      setAccepted(code);
    } catch (err) {
      setError(inviteErrorMessage(err));
    } finally {
      setChecking(false);
    }
  }

  if (accepted) return <RegistroPage inviteCode={accepted} />;

  return (
    <main className="auth">
      <div className="auth-card">
        <p className="brand" aria-hidden="true">
          <span className="brand-word">
            Dale<span className="dot">.</span>
          </span>
          <span className="brand-sub">Negocios</span>
        </p>
        <h1>Tu invitación a Dale</h1>
        <p className="lede">Tres meses gratis en el plan que elijas. Escribe la clave que te dimos.</p>
        {error ? <ErrorBanner message={error} /> : null}
        <form onSubmit={handleSubmit}>
          <FormField label="Clave de la invitación" htmlFor="invite-code">
            <input
              id="invite-code"
              name="invite-code"
              type="password"
              autoComplete="off"
              autoCapitalize="none"
              spellCheck={false}
              value={code}
              onChange={(event) => setCode(event.target.value)}
              required
            />
          </FormField>
          <button type="submit" className="btn" disabled={checking || !code}>
            {checking ? 'Revisando…' : 'Continuar'}
          </button>
        </form>
      </div>
    </main>
  );
}
